/**
 * System-recorded failure text only — not admin approval/rejection notes.
 * Order: `error_message` → `sync_metadata.lastError` → `sync_metadata.payoutRefund.refundReason`.
 */
export type RecordedFailureReasonInput = {
  errorMessage?: string | null;
  syncMetadata?: Record<string, unknown> | null;
};

export function getRecordedFailureReason(source: RecordedFailureReasonInput): string {
  const fromError = (source.errorMessage || '').trim();
  if (fromError) return fromError;

  const sync = source.syncMetadata ?? undefined;
  const lastError = sync?.lastError ?? sync?.last_error;
  if (typeof lastError === 'string' && lastError.trim()) return lastError.trim();

  const payoutRefund = sync?.payoutRefund as { refundReason?: unknown } | undefined;
  const fromRefund =
    typeof payoutRefund?.refundReason === 'string' ? payoutRefund.refundReason.trim() : '';
  if (fromRefund) return fromRefund;

  return '';
}

/** Same terminal statuses as transaction detail: show red banner only when there is a recorded (non–admin-notes) reason. */
const RECORDED_FAILURE_BANNER_STATUSES = ['failed', 'rejected', 'cancelled', 'expired'] as const;

export function shouldShowRecordedFailureBanner(status: string, recordedFailureReason: string): boolean {
  const reason = (recordedFailureReason || '').trim();
  if (reason.length === 0) return false;
  return (RECORDED_FAILURE_BANNER_STATUSES as readonly string[]).includes(status);
}
